import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Login Redux States
import { GET_ALL_PARAMETERS } from "./actionTypes";
import { getAllParamsSuccess, getAllParamsError } from "./actions";

// Include call API
import { getParameterAPI } from "../../../api/parameters";

const paramsAPI = getParameterAPI();

function* getAllParameters({ payload: { user } }) {
  try {
    const response = yield call(paramsAPI.getAllParameters, user.token);
    yield put(getAllParamsSuccess(response.params, response.message));
  } catch (error) {
    yield put(getAllParamsError(error));
  }
}

export function* watchGetParams() {
  yield takeEvery(GET_ALL_PARAMETERS, getAllParameters);
}

function* getAllParamsSaga() {
  yield all([fork(watchGetParams)]);
}

export default getAllParamsSaga;
